import type { VanDerValkPitchedCladdingType } from './pitchedCladdingFieldConfig'
import { buildPitchedVendorFrame, type PitchedVendorFrame } from './pitchedBomFrameProfiles'
import type { VanDerValkSuitabilityConfig } from './types'

export type { PitchedVendorFrame }

/**
 * Build vendor ``fields[*].frame`` for pitched-roof BOM from the resolved suitability row
 * and roof-derived cladding type.
 */
export function buildPitchedVendorFrameFromSuitabilityRow(
  row: VanDerValkSuitabilityConfig | null | undefined,
  claddingType: VanDerValkPitchedCladdingType
): PitchedVendorFrame | null {
  return buildPitchedVendorFrame(row, claddingType)
}
